import * as React from 'react';
import {Helmet} from 'react-helmet';

import {headTitle} from 'shells/document/head-title';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

import {PageTitleBar} from '../../layout';

import styles from './email-extension-page.module.css';

export function EmailGoogleExtensionPage() {
    return (
        <>
            <Helmet>
                <title>{headTitle('Chrome Extension')}</title>
            </Helmet>
            <PageTitleBar
                title='Chrome Extension'
                subheaderPrimaryText='Enhance your Google email inbox with the Nutshell Chrome Extension'
            />
            <div className='pad-32 background-white full-height'>
                <EmptyStateLarge
                    title='Enhance your Google email inbox with our Chrome Extension'
                    subtitle='See email sync status, add senders to Nutshell and view timelines.'
                    detailTextBullets={[
                        'Install the Nutshell Chrome Extension to enhance your Google web mail interface',
                        'Create Nutshell contacts and tasks from your inbox',
                        'See which emails have been shared with your teammates',
                        'Share email threads and messages directly from Gmail, without having to forward or bcc them to Nutshell',
                        'Business & Enterprise: Send Nutshell email templates directly from your Google inbox',
                    ]}
                    icon={
                        <img
                            alt=''
                            src='/include/images/email-marketing/email_inbox_empty_state_google.png'
                            className={styles.icon}
                        />
                    }
                    cta={
                        <Link
                            variant='button-primary'
                            size='xlarge'
                            href='https://chromewebstore.google.com/detail/nutshell-crm-for-gmail/fdekjafdhjnmacminpcdbakldlpkodij?hl=en-US'
                            // @ts-expect-error
                            target='_blank'
                        >
                            Install the Nutshell Chrome Extension
                        </Link>
                    }
                />
            </div>
        </>
    );
}
